if (!customElements.get('tab-content')) {
  class TabContent extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        button: '[tab-button]',
        content: '[tab-content]',
        video: 'video',
        tabGrid: '.tabs-head__grid',
        shadowLeft: '.tabs-head__shadow--left',
        shadowRight: '.tabs-head__shadow--right'
      };
      this.init();
    }

    init() {
      this.buttons = this.querySelectorAll(this.selectors.button);
      this.contents = this.querySelectorAll(this.selectors.content);
      this.tabGrid = this.querySelector(this.selectors.tabGrid);
      this.shadowLeft = this.querySelector(this.selectors.shadowLeft);
      this.shadowRight = this.querySelector(this.selectors.shadowRight);

      this.buttons?.forEach(button => {
        button?.addEventListener('click', this.onTabClick.bind(this));
      });
      this.observeVideos();

      // Shadow scroll logic
      if (this.tabGrid && this.shadowLeft && this.shadowRight) {
        this.tabGrid.addEventListener('scroll', this.updateShadows.bind(this));
        window.addEventListener('resize', this.updateShadows.bind(this));
        this.updateShadows();
      }
    }

    updateShadows() {
      const scrollLeft = this.tabGrid.scrollLeft;
      const maxScrollLeft = this.tabGrid.scrollWidth - this.tabGrid.clientWidth;
      this.shadowLeft.style.opacity = scrollLeft > 0 ? '1' : '0';
      this.shadowRight.style.opacity = scrollLeft < maxScrollLeft - 1 ? '1' : '0';
    }

    onTabClick(event) {
      const button = event.currentTarget;
      if (button.classList.contains('active')) {
        return;
      }

      // Pause the video in the currently active tab
      this.pauseVideosInActiveTab();

      const targetId = button.getAttribute('data-id');
      this.buttons.forEach(btn => btn.classList.remove('active'));
      this.contents.forEach(content => {
        content.classList.remove('active', 'fade-in');
      });

      button.classList.add('active');

      const targetContent = this.querySelector(`${this.selectors.content}[data-id="${targetId}"]`);
      if (targetContent) {
        targetContent.classList.add('active');
        setTimeout(() => {
          targetContent.classList.add('fade-in');
        }, 20);
        // Play the video in the newly active tab if it's visible
        this.playVideoIfVisible(targetContent);
      }
    }

    pauseVideosInActiveTab() {
      const activeContent = this.querySelector(`${this.selectors.content}.active`);
      if (activeContent) {
        const video = activeContent.querySelector(this.selectors.video);
        if (video && !video.paused) {
          video.pause();
        }
      }
    }

    playVideoIfVisible(content) {
      const video = content.querySelector(this.selectors.video);
      if (video) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              video.play();
            } else {
              video.pause();
            }
          });
        }, {
          threshold: [0.2] // 20% visibility
        });
        observer.observe(video);
      }
    }

    observeVideos() {
      this.contents.forEach(content => {
        this.playVideoIfVisible(content);
      });
    }
  }
  customElements.define('tab-content', TabContent);
}